import React from "react";

import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { WEB_URL } from "../api/URLs";
import { MixPanelTrackedLink } from "./MixPaneTrackedLink";
import { StyledFooter } from "./StyledComponents/FooterStyles";

export const Footer = () => {
    return <StyledFooter className="Footer">
        <Container className="FooterContainer">
            <Stack className="FooterMainStack">
                <Typography variant="small" color="neutral.main">&copy; {new Date().getFullYear()} The Citizens Foundation. All Rights Reserved.</Typography>

                <Divider flexItem />

                <Stack className="FooterLinksStack">
                    <MixPanelTrackedLink type="link" label="FAQs" context="Footer link" href={WEB_URL.FAQS} color="neutral.main" underline="none">
                        FAQs
                    </MixPanelTrackedLink>

                    <MixPanelTrackedLink type="link" label="PRIVACY POLICY" context="Footer link" href={WEB_URL.PRIVACY_POLICY} color="neutral.main" underline="none">
                        PRIVACY POLICY
                    </MixPanelTrackedLink>

                    <MixPanelTrackedLink type="link" label="SUPPORT" context="Footer link" href="mailto:contact@tcfglobal.org" color="neutral.main" underline="none">
                        SUPPORT
                    </MixPanelTrackedLink>
                </Stack>
            </Stack>
        </Container>
    </StyledFooter>
}